const MODAL_NAME = "setProjectStatusModal";

export { MODAL_NAME };
